angular.module('unergie.main')
.factory('BarcodeService', ($timeout) => {
    const ENERGY_CHECK_QR_CODE_REGEX = /^[`*0-9]{3}CHQ[0-9]{2}([0-9]{7})([0-9]{12})([0-9]{10})([0-9]{2})([0-9]{10})([`*0-9]{6})([0-9]{8}).{37}$/
    const CERTIFICATE_QR_CODE_REGEX = /^[`*0-9]{3}ATT[0-9]{2}([0-9]{10})([0-9]{8})([0-9]{8}).{49}$/
    const ENERGY_CHECK_DATA_MATRIX_REGEX = /^[`*0-9]{3}(CHQ)[0-9]{2}([0-9]{7})([0-9]{12})([0-9]{10})([0-9]{2})([`*0-9]{6})([0-9]{8}).{312}$/
    const CERTIFICATE_DATA_MATRIX_REGEX = /^[`*0-9]{3}(ATT)[0-9]{2}([0-9]{7})([0-9]{12})([0-9]{10})([0-9]{2})([0-9]{8})([0-9]{8}).{313}$/

    const convertEnergyCheckAmount = (str) => {
        return parseInt(str.replace(/[`*]*/g, ''), 10) / 100
    }

    const fillEnergyCheckWithQrCode = (str, payload) => {
        if (payload.type === 'CHECK') {
            const energyCheckMatches = ENERGY_CHECK_QR_CODE_REGEX.exec(str)
            if (energyCheckMatches && energyCheckMatches[3] === energyCheckMatches[5]) {
                payload.full_id = `${energyCheckMatches[1]}${energyCheckMatches[2]}${energyCheckMatches[3]}` // full check id (31 chars)
                payload.external_ref_1 = `${energyCheckMatches[1]}` // check id
                payload.external_ref_2 = `${energyCheckMatches[2]}` // check id
                payload.external_id_key = `${energyCheckMatches[4]}` // check id
                payload.external_id = `${energyCheckMatches[5]}` // check id
                payload.amount = convertEnergyCheckAmount(energyCheckMatches[6])
                payload.validity_date = energyCheckMatches[7]
                return true
            }
        }

        if (payload.type === 'CERTIFICATE') {
            const certificatekMatches = CERTIFICATE_QR_CODE_REGEX.exec(str)
            if (certificatekMatches) {
                payload.external_id = `${certificatekMatches[1]}`
                payload.check_date = certificatekMatches[2]
                payload.validity_date = certificatekMatches[3]
                return true
            }
        }
        return false
    }

    const fillEnergyCheckWithDataMatrix = (str, payload) => {
        if (payload.type === 'CHECK') {
            const energyCheckMatches = ENERGY_CHECK_DATA_MATRIX_REGEX.exec(str)
            if (energyCheckMatches && energyCheckMatches[1] === 'CHQ') {
                payload.external_ref_1 = `${energyCheckMatches[2]}` // check id
                payload.external_ref_2 = `${energyCheckMatches[3]}` // check id
                payload.external_id = `${energyCheckMatches[4]}` // check id
                payload.external_id_key = `${energyCheckMatches[5]}` // check id
                payload.amount = convertEnergyCheckAmount(energyCheckMatches[6])
                payload.validity_date = energyCheckMatches[7]
                return true
            }
        }

        if (payload.type === 'CERTIFICATE') {
            const certificatekMatches = CERTIFICATE_DATA_MATRIX_REGEX.exec(str)
            if (certificatekMatches && certificatekMatches[1] === 'ATT') {
                payload.external_ref_1 = `${certificatekMatches[2]}` // check id
                payload.external_ref_2 = `${certificatekMatches[3]}` // check id
                payload.external_id = `${certificatekMatches[4]}` // check id
                payload.external_id_key = `${certificatekMatches[5]}` // check id
                payload.check_date = certificatekMatches[6]
                payload.validity_date = certificatekMatches[7]
                return true
            }
        }
        return false
    }

    const fillEnergyCheckBackCompatible = (str, payload) => {
        return fillEnergyCheckWithQrCode(str, payload) || fillEnergyCheckWithDataMatrix(str, payload)
    }

    const handleEvent = (func, object) => {
        if (!func) {
            return () => {}
        }
        const scope = {}

        const cleanScan = function () {
            delete scope.scannedChars
            if (scope.cleanScanTimeout) {
                $timeout.cancel(scope.cleanScanTimeout)
                delete scope.cleanScanTimeout
            }
        }

        return (e) => {
            let { key } = e
            if (key === 'Alt' || key === 'AltGraph' || key === 'Shift') {
                // just ignore it
                return
            }
            if (key === 'Dead') {
                key = '`' // macos is really strange...
            }
            if (key === 'Enter') {
                if (!scope.scannedChars) {
                    // nothing typed recently, not a scan
                    return
                }
                // in all cases, do not keep chars after that
                const chars = scope.scannedChars
                delete scope.scannedChars
                // handle bar code
                const isHandled = func(chars, object)
                if (isHandled) {
                    e.preventDefault()
                    e.stopPropagation()
                }
            } else if (!key || key.length > 1) {
                // not a char key, not a scan
                cleanScan()
            } else {
                // simple key, add it to buffer
                if (scope.scannedChars) {
                    scope.scannedChars += key
                } else {
                    scope.scannedChars = key
                }
                // cancel cleaning promise
                if (scope.cleanScanTimeout) {
                    $timeout.cancel(scope.cleanScanTimeout)
                }
                scope.cleanScanTimeout = $timeout(scope.cleanScan, 500)
            }
        }
    }

    return {
        fillEnergyCheckBackCompatible,
        handleEvent,
    }
})
